export default "__VITE_ASSET__CASnwcFX__"